export const SET = 'workshopSession/SET';
